import { render, staticRenderFns } from "./FloatingButtonsWizard.vue?vue&type=template&id=7aefc64d&scoped=true"
import script from "./FloatingButtonsWizard.vue?vue&type=script&lang=js"
export * from "./FloatingButtonsWizard.vue?vue&type=script&lang=js"
import style0 from "./FloatingButtonsWizard.vue?vue&type=style&index=0&id=7aefc64d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aefc64d",
  null
  
)

export default component.exports